'use client';

import Link from 'next/link';
import { ACCEPT_ALL_COOKIE_CONSENT, CookieConsent, DEFAULT_COOKIE_CONSENT } from '@/features/cookie-consent';
import { CookieConsentSettings } from '@/features/cookie-consent/ui/cookie-consent-settings';
import { COOKIES_POLICY_PATHNAME } from '@/shared/constants/pathnames';
import { Button, DialogHeader, DialogTitle, Text } from '@/shared/ui/core';
import { useCookieConsent } from '../model/use-cookie-consent';
import { useCookieConsentStore } from '../model/cookie-consent.store';
import styles from './cookie-consent.module.scss';


export function CookieConsentContent () {
    const { saveConsent } = useCookieConsent();
    const view            = useCookieConsentStore((state) => state.view);
    const setView         = useCookieConsentStore((state) => state.setView);
    const close           = useCookieConsentStore((state) => state.close);

    const isSettings = view === 'settings';

    async function save (next: CookieConsent): Promise<void> {
        await saveConsent(next);
        close();
    }

    return (
        <>
            <DialogHeader className={ styles.dialog_header }>
                <DialogTitle>
                    <Text
                        weight='semibold'
                        lineHeight={ 1 }
                        className={ styles.dialog_title }
                    >
                        We would like to inform you that we use cookies
                    </Text>
                </DialogTitle>
            </DialogHeader>

            <div className={ styles.root }>
                <div>
                    <Text
                        as='p'
                        lineHeight={ 1.2 }
                    >
                        We use cookies to improve your experience. Read our&nbsp;
                        <Link
                            href={ COOKIES_POLICY_PATHNAME }
                            target='_blank'
                            className={ styles.link }
                            prefetch={ false }
                        >
                            cookie policy
                        </Link>
                        &nbsp;or&nbsp;
                        {
                            !isSettings &&
                            <Button
                                variant='naked'
                                onClick={ () => setView('settings') }
                            >
                                <Text
                                    as='span'
                                    lineHeight={ 1.2 }
                                    className={ styles.inline_button }
                                >
                                    manage cookies
                                </Text>
                            </Button>
                        }
                        {
                            isSettings &&
                            <Text
                                as='span'
                                lineHeight={ 1.2 }
                            >
                                manage cookies
                            </Text>
                        }.
                    </Text>
                </div>

                <div className={ styles.controls }>
                    {
                        !isSettings &&
                        <>
                            <Button
                                variant='primary'
                                onClick={ () => void save(ACCEPT_ALL_COOKIE_CONSENT) }
                            >
                                Accept all
                            </Button>

                            <Button
                                variant='secondary'
                                onClick={ () => void save(DEFAULT_COOKIE_CONSENT) }
                            >
                                Reject all
                            </Button>
                        </>
                    }
                    {
                        isSettings &&
                        <CookieConsentSettings/>
                    }
                </div>
            </div>
        </>
    );
}
